import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DisclamerModelState {
  isOpen: boolean;
}

const initialState: DisclamerModelState = {
  isOpen: false,
};

const DisclamerModelSlice = createSlice({
  name: "DisclamerModel",
  initialState,
  reducers: {
    setIsOpen: (state: DisclamerModelState, action: PayloadAction<any>) => {
      state.isOpen = action.payload;
    },
  },
});

export const { setIsOpen } = DisclamerModelSlice.actions;
export default DisclamerModelSlice.reducer;
